import { logger } from 'helpers'
var endpoints = {}
try {
  endpoints = require('../projects/' + process.env.REACT_APP_PROJECT + '/config/endpoints')
} catch (e) {
  logger.debug('No project-specific config for endpoints')
}
module.exports = endpoints



// WEBPACK FOOTER //
// ./src/config/endpoints.js